import { render, staticRenderFns } from "./current_user_block.vue?vue&type=template&id=65156456&scoped=true&"
import script from "./current_user_block.vue?vue&type=script&lang=js&"
export * from "./current_user_block.vue?vue&type=script&lang=js&"
import style0 from "./current_user_block.vue?vue&type=style&index=0&id=65156456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65156456",
  null
  
)

export default component.exports